export default {
    type: 'text',
    format: {},
    default: {
        logic: 'contains'
    },
    setting: {
        logic: ['contains']
    },
    link: {},
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Comment Text',
        category: ['User', 'Collection'],
        description: 'Search keywords inside the comment on a game.',
        placeholder: 'Enter search term...',
        summarise: {
            template: {
                contains: {
                    '=': 'Comments containing the term "{value}"',
                    '!=': 'Comments not containing the term "{value}"'
                }
            }
        }
    }
}